var exports = {
  "kL": "x93eb46d8--878dc6--container",
  "Xj": "x93eb46d8--878dc6--container_under-construction",
  "Kk": "x93eb46d8--878dc6--icon",
  "UU": "x93eb46d8--878dc6--name",
};

module.exports = exports;
